import { Module,GetterTree } from 'vuex';
import { RootState } from '../types';
import { ConfigState } from './types';

export const state: ConfigState = {
    inputProps:{
        outlined: true,
    },
    colors:{
        primary: '#fd8908',
        secondary: '#6589b8',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    },
    version: GIT_DESCRIBE.tag,
    company: process.env.VUE_APP_COMPANY || 'WINGS',
    company_url: process.env.VUE_APP_COMPANY_URL || 'https://wsoft.ru/product-overview',
    registration_activation: process.env.VUE_APP_REGISTRATION_ACTIVATION && process.env.VUE_APP_REGISTRATION_ACTIVATION.toLowerCase() === "true",
    only_english: process.env.VUE_APP_ONLY_ENGLISH && process.env.VUE_APP_ONLY_ENGLISH.toLowerCase() === 'true',
    use_captcha: process.env.VUE_APP_USE_CAPTCHA && process.env.VUE_APP_USE_CAPTCHA.toLowerCase() === 'true',
};
export const getters: GetterTree<ConfigState,RootState> = {
    config: state => state,
};

export const config: Module<ConfigState,RootState> = {
    state,
    getters,
};